<div
    *ngIf="data"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
    fxLayoutGap="10px"
    id="new-version-snackbar"
    class="new-version-snackbar"
>
    <div id="new-version-message" fxFlex="auto" fxFlex.xs="100%" class="message">
        {{ data.message }}
    </div>
    <div fxFlex.xs="100%" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px" class="action">
        <button id="new-version-reload-btn" mat-raised-button color="primary" (click)="onReload()">
            {{ data.reloadBtn }}
        </button>
    </div>
</div>
